import styled from "styled-components";

export const Container = styled.div`
  width: 98%;
  margin: 10px auto 14px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14);
  overflow: hidden;
`;

export const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(90deg, #0b4f6c 0%, #1e958c 60%, #1e88e5 100%);
  color: #ffffff;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const TitleText = styled.span`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const SelectArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.18);
`;

export const SelectItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  border-radius: 999px;
  border: ${({ selected }) =>
    selected ? "2px solid rgba(255, 255, 255, 0.9)" : "1px solid rgba(255, 255, 255, 0.4)"};
  background: ${({ selected }) =>
    selected ? "rgba(255, 255, 255, 0.95)" : "transparent"};
  opacity: ${({ selected }) => (selected ? 1 : 0.8)};
  transition: opacity 0.15s ease-out, transform 0.15s ease-out;

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
  }
`;

export const TextSelection = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ color }) => color};
`;

export const FoodsArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 6px 12px;
  padding: 10px 12px 14px;
`;

export const QuestionsArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0;
  padding: 0 12px 10px;

  @media only screen and (max-width: 610px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const QuestionText = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const InfoTitle = styled.span`
  font-size: 12px;
  margin-left: 10px;
`;
